import React, { useContext, useState, useEffect, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { BrandContext } from '../../contexts/brand-context';
import { FormatPhoneInput, GetEmailRegex } from "../../services/utilities";
import { Helmet } from 'react-helmet-async';
import { useForm } from "react-hook-form";
import apiPublic from '../../services/api-public';
import apiTools from '../../services/api-tools';
import SpinnerLoader from '../layout/spinner-loader';
import orderBy from 'lodash/orderBy';
import find from 'lodash/find';
import { toTitleCase } from '../../services/utilities';
import { DateTime } from 'luxon';

const PropertyProfile = () => {
    const { selectedBrand } = useContext(BrandContext);
    const { register, handleSubmit, setValue, formState: { errors } } = useForm();
    const [emailSent, setEmailSent] = useState(false);
    const [phoneInputValue, setPhoneInputValue] = useState("");
    const [loadingCounties, setLoadingCounties] = useState(true);
    const [loading, setLoading] = useState(false);
    const [submissionError, setSubmissionError] = useState(false);
    const [loadingSearchResults, setLoadingSearchResults] = useState(false);
    const [loadingPropertyResults, setLoadingPropertyResults] = useState(false);
    const [toolCounties, setToolCounties] = useState([]);
    const [searchText, setSearchText] = useState(null);
    const [searchCounty, setSearchCounty] = useState(null);
    const [selectedCountyInfo, setSelectedCountyInfo] = useState(null);
    const [csEmailAddress, setCsEmailAddress] = useState(null);
    const [noResults, setNoResults] = useState(false);
    const [moreResults, setMoreResults] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const [propertyInfo, setPropertyInfo] = useState(null);
    const [productType, setProductType] = useState(null);
    const [dateInputValue, setDateInputValue] = useState(null);
    const [timeInputValue, setTimeInputValue] = useState(null);
    const [uploadedFiles, setUploadedFiles] = useState([])
    const [fileLimit, setFileLimit] = useState(false);
    const [countyDdl, setCountyDdl] = useState([])
    const [geoCounty, setGeoCounty] = useState(false);
    const MAX_COUNT = 3;

    useEffect(() => {
        const GetToolCounties = async () => {
            setLoadingCounties(true);
            apiTools.get(`/tool-counties/TaxCalc`)
                .then((response) => {
                  
                    setToolCounties(response.data);
                    setLoadingCounties(false);
                });
        }
        GetToolCounties();

        const getAllCounties = async () => {

            const response = await apiPublic.get(`orderform-counties`);
            setCountyDdl(response.data);
        }
        getAllCounties();
        checkDayOfWeek();
    }, []);

    function handleSelectChange(countySelected) {
        countySelected = countySelected.toUpperCase();
        var county;
        var found = find(toolCounties, sc => (sc.county === countySelected));
        if (found) county = found;
        if (county) {
            setGeoCounty(true);
        } else {
            setGeoCounty(false)
        }
        setSearchCounty(countySelected);
        setSelectedCountyInfo(countySelected);
    };

    useEffect(() => {
        if (selectedBrand && searchCounty) {
            var csEmailAddr = selectedBrand.regions[0].stateAndCounties[0].csEmailAddress;
            var regionForCounty = selectedBrand.regions.find(r => r.stateAndCounties.some(sc => sc.county === searchCounty.toUpperCase()));
            if (regionForCounty) {
                var county = regionForCounty.stateAndCounties.find(sc => sc.county === searchCounty.toUpperCase());
                if (county) {
                    csEmailAddr = county.csEmailAddress;
                }
            }
            setCsEmailAddress(csEmailAddr);
        }
    }, [searchCounty]);


    function checkDayOfWeek() {
        var defaultTime = DateTime.now().plus({ minutes: 120 }).toFormat("HH:mm:ss");
        var defaultDate = DateTime.now();

        if (defaultTime >= "17:00:00") {
            defaultDate = DateTime.now().plus({ days: 1 });
            defaultTime = "08:30:00";
        }
   
        var dayOfWeek = defaultDate.toFormat("cccc");
        if (dayOfWeek === "Saturday") {
            defaultDate = DateTime.now().plus({ days: 2 });
            defaultTime = "08:30:00";
        } else if (dayOfWeek === "Sunday") {
            defaultDate = DateTime.now().plus({ days: 1 });
            defaultTime = "08:30:00";
        }

        defaultDate = defaultDate.toFormat("yyyy-MM-dd");
        setDateInputValue(defaultDate);
        setTimeInputValue(defaultTime);
    }


    const checkTime = (e) => {
        if (e.target.value >= "17:00:00") {
            setDateInputValue(DateTime.now().plus({ days: 1 }).toFormat("yyyy-MM-dd"));
            var defaultTime = "08:30:00";
            setTimeInputValue(defaultTime);
        } else {
            setTimeInputValue(e.target.value);
        }
    };

    const saveProduct = (e) => {
        setProductType(e.target.value);
        setValue('product', e.target.value, { shouldValidate: true });
    };

    const onSubmit = data => {
        const fileNames = uploadedFiles.map(file => {
           return file.name
        })

        //Add files back to FileList for upload
        let fList = new DataTransfer();
        uploadedFiles.forEach((f) => {
            let ufile = new File([f], f.name);
            fList.items.add(ufile);
        });
       
        var pAddress = (geoCounty && propertyInfo) ? propertyInfo.siteAddress : searchText;
        var byDate = (!data.neededByDate) ? dateInputValue : data.neededByDate;
      
        const emailOrderObject = {
            name: data.name,
            company: data.company,
            customerAddress: data.customerAddress,
            customerZip: data.customerZip,
            customerCity: data.customerCity,
            customerState: data.customerState,
            customerPhone: data.customerPhone,
            customerEmail: data.email,
            propertyCounty: toTitleCase(searchCounty),
            propertyAddress: pAddress,
            propertyZip: data.propertyZip,
            propertyCity: data.propertyCity,
            propertyState: data.propertyState,
            legalDesc: data.legalDesc,
            owner: data.owner,
            propertyType: data.propertyType,
            product: data.product,
            neededByDate: byDate,
            neededByTime: timeInputValue,
            subdivision: data.subdivision,
            deliverMethod: data.deliverMethod,
            notes: data.notes,
            fileUpload: JSON.stringify(fileNames),
            brand: selectedBrand
        }

        const sendEmail = async () => {
            await apiPublic.post(`/web-order`, emailOrderObject)
                .then((response) => {
                    const orderId = response.data;
                    if (fList.files && fList.files[0]) {
                        const loadOrderFiles = async () => {
                            var fileUploadOneAtATimePromises = [];
                            for (var i = 0; i < fList.files.length; i++) {
                                var dt = new DataTransfer();
                                dt.items.add(fList.files.item(i));
                                const promise = apiPublic.post(`/save-web-order-attachments?orderId=` + orderId, dt.files, { noErrorHandling: true });
                                fileUploadOneAtATimePromises.push(promise);
                            }
                            Promise.all(fileUploadOneAtATimePromises)
                                .then((uploadresponse) => {
                                    setLoading(false);
                                    setEmailSent(true);
                                    setSubmissionError(false);
                                })
                                .catch((err) => {
                                    setLoading(false);
                                    setSubmissionError(true);
                                });
                        };
                        loadOrderFiles();
                    }
                    else {
                        setEmailSent(true)
                    }
                });
        }
        setLoading(true);
        sendEmail();
    }

    const handleCustomerPhoneInput = (e) => {
        const formattedPhoneNumber = FormatPhoneInput(e.target.value);
        setValue('customerPhone', formattedPhoneNumber, { shouldValidate: true });

    };

    const autoFillBasedOnZip = async (zipInput, zipType) => {
        setValue(zipInput.name, zipInput.value, { shouldValidate: true });
        if (zipInput.value.length === 5) {
            apiPublic.get(`/zipcodeinfo/${zipInput.value}`)
                .then((response) => {
                    if (zipType === "customerZip") {
                        setValue('customerCity', response.data.city);
                        setValue('customerState', response.data.stateAbbr);
                    } else if (zipType === "propertyZip") {
                        setValue('propertyCity', response.data.city);
                        setValue('propertyState', response.data.stateAbbr);
                    }
                });
        }
    };

    function doSearch() {
        setNoResults(false);
        setMoreResults(false);
        setPropertyInfo(null);
        if (searchText === null) {
            setSearchText("");
            return;
        }
        if (searchCounty === null) {
            setSearchCounty("");
            return;
        } else {
            setSearchCounty(searchCounty);
        }
        if (searchCounty !== null && searchCounty !== "" && searchText !== null && searchText !== "") {
            setLoadingSearchResults(true);
            var selectedCounty = find(toolCounties, sc => (sc.county === searchCounty));
            setSelectedCountyInfo(selectedCounty);
            var searchCriteria = {
                address: searchText,
                county: selectedCounty.county,
                state: selectedCounty.state
            };
            getSearchResults(searchCriteria);
        }
    }

    const getSearchResults = async (searchCriteria) => {
        apiTools.get(`/property-search?state=${searchCriteria.state}&county=${searchCriteria.county}&searchType=siteAddr&value=${searchCriteria.address}`)
            .then((response) => {
                setSearchResults(response.data.records);
                if (response.data.records.length === 0) {
                    setNoResults(true);
                }
                if (response.data.totalCount > response.data.currentCount) {
                    setMoreResults(true);
                }
                setLoadingSearchResults(false);
            });
    }

    function fillPropertyInfo(property) {
        setLoadingPropertyResults(true);
        setPropertyInfo(null);

        apiTools.get(`/property-profile?state=${selectedCountyInfo.state}&county=${selectedCountyInfo.county}&parcelId=${property.parcelId}`)
            .then((response) => {
                setPropertyInfo(response.data);
                setValue('owner', response.data.ownerName);
                setValue('legalDesc', response.data.legalDescription, { shouldValidate: true });
                setValue('propertyZip', response.data.siteZip, { shouldValidate: true });
                setValue('propertyCity', response.data.siteCity);
                setValue('propertyState', response.data.siteState);
                setValue('address', response.data.siteAddress, { shouldValidate: true });
                setLoadingPropertyResults(false);
            });
    }

    const handleFileEvent = (e) => {
        const chosenFiles = Array.prototype.slice.call(e.target.files)
        handleUploadFiles(chosenFiles);
    }

    const handleUploadFiles = files => {
        var uploaded = [...uploadedFiles];
        let limitExceeded = false;
        limitExceeded = files.some((file) => {
            if (uploaded.findIndex((f) => f.name === file.name) === -1) {
                uploaded.push(file);
                if (uploaded.length === MAX_COUNT) setFileLimit(true);
                if (uploaded.length > MAX_COUNT) {
                    alert(`You can only add a maximum of ${MAX_COUNT} files`);
                    setFileLimit(false);
                    limitExceeded = true;
                    setValue('attachment', "");
                    setUploadedFiles("");
                    return true;
                }
            }
            return false;
        })
        if (!limitExceeded) setUploadedFiles(uploaded)
    }

    return (
        <>
            <Helmet>
                <title>Property Profile : {selectedBrand.brandName} </title>
            </Helmet>
            <h1>Property Profile</h1>
            <div className="row">
                <div className="col-12">
                    <p>Want a faster way to get your Property Profile? <Link to="/propertyone">Do it yourself in seconds with PropertyOne.</Link></p>

                    {emailSent && <>
                        <p><strong>Thank you for your order! A team member will be contacting you soon.</strong></p>
                        <p>Enter another order:<br /><Link to="/title-and-escrow-order" className="btn btn-primary btn-sm">Title & Escrow Order</Link> <Link to="/home-portfolio-form" className="btn btn-primary btn-sm">Home Portfolio</Link> <Link to="/property-profile" reloadDocument className="btn btn-primary btn-sm">Property Profile</Link></p>
                    </>}
                    {!emailSent && loading && <><p className="fw-bold text-center">Submitting. Please wait for the confirmation.</p><SpinnerLoader /></>}
                    {!emailSent && !loading && submissionError && <><p className="text-danger fw-bold">We're sorry, there has been a problem submitting your order.  Please contact customer service at <a href={"mailto:" + csEmailAddress}>{csEmailAddress.toLowerCase()}</a>. </p></>}
                    {!loading && !emailSent &&
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <h2>Customer Information:</h2>

                        <div className="row pb-1">
                            <label htmlFor="name" className="col-12 col-sm-4 col-md-3 text-md-end required">
                                Your Name:
                            </label>
                            <div className="col-12 col-sm-6 col-md-8">
                                <input autoComplete="name" name="name" type="text" id="name" className="form-control" {...register("name", { required: true })} />
                                {errors?.name?.type === "required" && <small className="text-danger">This field is required</small>}
                            </div>
                        </div>
                        <div className="row pb-1">
                            <label htmlFor="company" className="col-12 col-sm-4 col-md-3 text-md-end required">
                                Company:
                            </label>
                            <div className="col-12 col-sm-6 col-md-8">
                                <input name="company" type="text" id="company" className="form-control" {...register("company", { required: true })} />
                                {errors?.company?.type === "required" && <small className="text-danger">This field is required</small>}
                            </div>
                        </div>
                        <div className="row pb-1">
                            <label htmlFor="customerAddress" className="col-12 col-sm-4 col-md-3 text-md-end">
                                Company Address:
                            </label>
                            <div className="col-12 col-sm-6 col-md-8 pb-2 pb-lg-0">
                                <input autoComplete="street-address" name="customerAddress" type="text" id="customerAddress" className="form-control" {...register("customerAddress")} />
                            </div>
                        </div>
                        <div className="row pb-1">
                            <div className="offset-sm-3 col-8 col-lg-3 col-xl-2 pb-2 pb-lg-0">
                                <input autoComplete="postal-code" name="customerZip" type="text" id="customerZip" maxLength="5" className="form-control" placeholder="Zip Code" {...register("customerZip")} onChange={(e) => { autoFillBasedOnZip(e.target, e.target.name); }} />
                            </div>
                            <div className="offset-sm-3 offset-lg-0 col-8 col-lg-3 pb-2 pb-lg-0">
                                <input name="customerCity" type="text" id="customerCity" className="form-control" placeholder="City" {...register("customerCity")} />
                            </div>
                            <div className="offset-sm-3 offset-lg-0 col-8 col-lg-2 col-xl-1">
                                <input name="customerState" type="text" maxLength="2" id="customerState" className="form-control" placeholder="State" {...register("customerState")} />
                            </div>
                        </div>
                        <div className="row pb-1">
                            <label htmlFor="customerPhone" className="col-12 col-sm-4 col-md-3 text-md-end required">Phone Number:
                            </label>
                            <div className="col-8 col-lg-3 pb-2 pb-lg-0">
                                <input autoComplete="tel" name="customerPhone" type="tel" id="customerPhone" className="form-control" {...register("customerPhone", { required: true, minLength: 12 })} onChange={(e) => handleCustomerPhoneInput(e)} />
                                {errors?.customerPhone?.type === "required" && <small className="text-danger">This field is required</small>}
                                {errors?.customerPhone?.type === "minLength" && <small className="text-danger">Enter a valid phone number</small>}
                            </div>
                        </div>
                        <div className="row pb-1">
                            <label htmlFor="email" className="col-12 col-sm-4 col-md-3 text-md-end required">Email:</label>
                            <div className="col-12 col-sm-6 col-md-8">
                                    <input autoComplete="email" name="email" type="email" id="email" className="form-control" {...register("email", { required: true, pattern: GetEmailRegex() })} />
                                    {errors?.email?.type === "required" && <small className="text-danger">This field is required</small>}
                                    {errors?.email?.type === "pattern" && <small className="text-danger">Please enter a valid email address</small>}
                            </div>
                        </div>
                        <h2 className="pt-1">Property Information:</h2>


                        {loadingCounties && <SpinnerLoader />}
                        {!loadingCounties && countyDdl.length > 0 &&
                            <>
                                <div className="row pb-1">
                                    <label htmlFor="County" className="col-12 col-sm-4 col-md-3 text-md-end required">Property County:
                                    </label>
                                    <div className="col-12 col-sm-6 col-md-8 no-localization">
                                        {countyDdl.length > 1 &&    
                                            <select autoComplete="chrome-off" name="County" className="form-select" id="County" aria-label="Select County" {...register("County", { required: true })} onChange={(e) => { handleSelectChange(e.target.value); }}>
                                            <option key="-1" value="">- SELECT COUNTY -</option>
                                            <option key="-2" value="" disabled>- IDAHO -</option>
                                            {countyDdl && countyDdl.map(function (c, idx) {
                                                return <Fragment key={idx}>
                                                    {(idx === 44) &&
                                                        <><option key="-3" value="" disabled>- MONTANA -</option><option key="83" value="Gallatin">Gallatin</option><option key="-4" value="" disabled>- WASHINGTON -</option></>
                                                    } else {
                                                        <option key={idx} value={c.countyName}>{c.countyName}</option>
                                                    }
                                                </Fragment>;
                                            }
                                            )} 
                                            </select>
                                        }
                                        {errors?.County?.type === "required" && <small className="text-danger">This field is required</small>}
                                       
                                    </div>
                                </div>
                                <div className="row pb-1">
                                    <label htmlFor="address" className="col-12 col-sm-4 col-md-3 text-md-end required">
                                        Property Address:
                                    </label>
                                    <div className="col-12 col-sm-6 col-md-8 pb-2 pb-lg-0">
                                        <input autoComplete="chrome-off" name="address" type="text" id="address" className="form-control"  {...register("address", { required: true })} onChange={(e) => { setSearchResults([]); setNoResults(false); setSearchText(e.target.value); }} />
                                        {errors?.address?.type === "required" && <small className="text-danger">This field is required</small>}
                                    </div>
                                </div>
                                {geoCounty ? <div className="row pb-2">
                                    <div className="offset-sm-3 col-8 col-lg-3 col-xl-2">
                                       
                                        <input className="btn btn-primary" type="button" value="Search" onClick={() => doSearch()} />
                                    </div>
                                </div> : null}
                            </>
                        }

                        {(loadingSearchResults || loadingPropertyResults) && <SpinnerLoader />}

                        {!loadingSearchResults && noResults &&
                            <div className="row pt-2">
                                <div className="row offset-0 offset-lg-3">
                                    <p className="fw-bold">No results found.</p>

                                    <p>
                                        Please try your search again. 
                                    </p>
                                </div>
                            </div>
                        }

                        {!loadingSearchResults && searchResults.length > 0 && !loadingPropertyResults && propertyInfo == null &&
                            <>
                                {searchResults.length > 1 && <div className="row offset-0 offset-lg-3"><div className="col-12 fw-bold">Multiple properties were found. Please select a property:</div></div>}
                                {searchResults.length === 1 && <div className="row offset-0 offset-lg-3"><div className="col-12 fw-bold">Please confirm this is the property you are looking for:</div></div>}
                                <div className="row offset-0 offset-lg-3">
                                    <div className="col-5 col-lg-4 fw-bold">Address</div>
                                    <div className="col-5 col-lg-4 fw-bold">Owner</div>
                                    <div className="col-2"></div>
                                    <div className="col-0 col-lg-2"></div>
                                </div>
                                {orderBy(searchResults, ['siteAddress']).map((p, idx) =>
                                    <div className="row offset-0 offset-lg-3 pb-2" key={idx}>
                                        <div className="col-5 col-lg-4 lg-sm no-localization">{p.siteAddress}</div>
                                        <div className="col-5 col-lg-4 lg-sm no-localization">{p.ownerName}</div>
                                        <div className="col-2">
                                            <button className="btn btn-primary btn-sm" onClick={() => fillPropertyInfo(p)}>Select</button>
                                        </div>
                                        <div className="col-0 col-lg-2"></div>
                                    </div>)
                                }
                                {moreResults && <div className="row offset-0 offset-lg-3"><div className="col-12 fw-bold">More than {searchResults.length} properties were found, please enter a more precise address.</div></div>}
                            </>
                        }

                        <div className="row pb-1">
                            <div className="offset-sm-3 col-8 col-lg-3 col-xl-2 pb-2 pb-lg-0">
                                <input autoComplete="chrome-off" name="propertyZip" type="text" id="propertyZip" maxLength="5" className="form-control" placeholder="Zip Code" {...register("propertyZip", { required: true })} onChange={(e) => { autoFillBasedOnZip(e.target, e.target.name); }} />
                                {errors?.propertyZip?.type === "required" && <small className="text-danger">Required</small>}
                            </div>
                            <div className="offset-sm-3 offset-lg-0 col-8 col-lg-3 pb-2 pb-lg-0">
                                <input autoComplete="chrome-off" name="propertyCity" type="text" id="propertyCity" className="form-control" placeholder="City" {...register("propertyCity")} />
                            </div>
                            <div className="offset-sm-3 offset-lg-0 col-8 col-lg-2 col-xl-1">
                                <input autoComplete="chrome-off" name="propertyState" type="text" maxLength="2" id="propertyState" className="form-control" placeholder="State" {...register("propertyState")} />
                            </div>
                        </div>
                        <div className="row pb-1">
                            <label htmlFor="legalDesc" className="col-12 col-sm-4 col-md-3 text-md-end required">
                                Legal Desc:
                            </label>
                            <div className="col-12 col-sm-6 col-md-8 no-localization">
                                <textarea name="legalDesc" rows="3" cols="20" id="legalDesc" className="form-control" {...register("legalDesc", { required: true })} ></textarea>
                                {errors?.legalDesc?.type === "required" && <small className="text-danger">This field is required</small>}
                            </div>
                        </div>
                        <div className="row pb-1">
                            <label htmlFor="owner" className="col-12 col-sm-4 col-md-3 text-md-end">
                                Owner: (if avail.)
                            </label>
                            <div className="col-12 col-sm-6 col-md-8 pb-2 pb-lg-0 no-localization">
                                <input autoComplete="chrome-off" name="owner" type="text" id="owner" className="form-control" {...register("owner")} />
                            </div>
                        </div>
                        <div className="row pb-1">
                            <label htmlFor="propertyType" className="col-12 col-sm-4 col-md-3 text-md-end">
                                Type:
                            </label>
                            <div className="col-12 col-sm-6 col-md-8 pb-2 pb-lg-0">
                                <select name="propertyType" id="propertyType" className="form-select" aria-label="Select Type" {...register("propertyType")}>
                                    <option value="Residential">Residential</option>
                                    <option value="Commercial">Commercial</option>
                                    <option value="Agricultural">Agricultural</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                        </div>
                        <h2 className="pt-1">Order Information:</h2>
                        <div className="row pb-1">
                            <div className="offset-sm-3">
                                Listing Package/Property Profile includes deeds, map, taxes, ownership & CC&Rs.
                            </div>
                        </div>
                        <div className="row pb-1">
                            <label htmlFor="product" className="col-12 col-sm-4 col-md-3 text-md-end required">
                                Product:
                            </label>
                            <div className="col-12 col-sm-6 col-md-8 pb-2 pb-lg-0">
                                <select name="product" id="product" className="form-select" aria-label="Select Product" {...register("product", { required: true })} onChange={(e) => { saveProduct(e); }}>
                                    <option key="-1" value="">- SELECT -</option>
                                    <option value="Listing Package/Property Profile">Listing Package/Property Profile</option>
                                    <option value="CC&Rs Only">CC&Rs Only</option>
                                    <option value="Ownership">Ownership</option>
                                </select>
                                {errors?.product?.type === "required" && <small className="text-danger">This field is required</small>}
                            </div>
                        </div>
                        <div className="row pb-1">
                            <label className="col-12 col-sm-4 col-md-3 text-md-end required">
                                Needed By Date/Time:
                            </label>
                            <div className="col-12 col-sm-3 col-md-4">
                                <input id="neededByDate" className="form-control" aria-label="Need by Date" type="date" required {...register("neededByDate")} defaultValue={dateInputValue} min={dateInputValue}/>
                            </div>
                            <div className="col-12 col-sm-3 col-md-4">
                                <input id="neededByTime" className="form-control" aria-label="Need by Time" type="time" defaultValue={timeInputValue} {...register("neededByTime")} onChange={(e) => checkTime(e)} />
                            </div>
                        </div>

                        {(productType === "CC&Rs Only") && <div className="row pb-1">
                            <label htmlFor="subdivision" className="col-12 col-sm-4 col-md-3 text-md-end required">
                                Subdivision:
                            </label>
                            <div className="col-12 col-sm-6 col-md-8 pb-2 pb-lg-0">
                                <input name="subdivision" type="text" id="subdivision" className="form-control" {...register("subdivision", { required: true })} />
                                {errors?.subdivision?.type === "required" && <small className="text-danger">This field is required</small>}
                            </div>
                        </div>
                        }

                        <div className="row pb-1">
                            <label htmlFor="deliverMethod" className="col-12 col-sm-4 col-md-3 text-md-end">
                                Deliver Via:
                            </label>
                            <div className="col-12 col-sm-6 col-md-8 pb-2 pb-lg-0">
                                <select name="deliverMethod" id="deliverMethod" className="form-select" aria-label="Select Deliver Method" {...register("deliverMethod")}>
                                    <option value="Email">Email</option>
                                    <option value="Fax">Fax</option>
                                    <option value="Hand Delivery">Hand Delivery</option>
                                    <option value="Pick Up">Pick Up</option>
                                </select>
                            </div>
                        </div>
                        <div className="row pb-1">
                            <label htmlFor="notes" className="col-12 col-sm-4 col-md-3 text-md-end">
                                Notes:
                            </label>
                            <div className="col-12 col-sm-6 col-md-8 pb-2 pb-lg-0">
                                <textarea name="notes" rows="2" cols="20" id="notes" className="form-control" {...register("notes")}></textarea>
                            </div>
                        </div>
                        <div className="row pb-1">
                                <label htmlFor="attachment" className="col-12 col-sm-4 col-md-3 text-md-end">
                                Attach File(s):<br />
                                Maximum Files: 3
                            </label>
                            <div className="col-12 col-sm-6 col-md-8 pb-2 pb-lg-0">    
                                    <input name="attachment" type="file" id="attachment" className="pt-2" multiple {...register("attachment")} onChange={handleFileEvent} disabled={fileLimit} />
                                  
                                    <div className="uploaded-files-list">
                                        {uploadedFiles && uploadedFiles.map(file => (
                                            <div key={file.name}>
                                                {file.name}
                                            </div>
                                        ))}
                                    </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-4 col-md-3"></div>
                            <div className="col-12 col-sm-6 col-md-8 mb-1">
                                <input type="submit" value="Submit Order" className="btn btn-primary float-end" />
                            </div>
                        </div>
                    </form>}
                </div>
            </div>
        </>
    );
}

export default PropertyProfile;